// extracted by mini-css-extract-plugin
module.exports = {"container":"profileRef_container__1Rw2b","avatar":"profileRef_avatar__1W-A6"};